<template>
  <div class="pick-up-info">
    <basic-form
      title="Pick Up Info"
      ref="infoForm"
      :form-params="whatToShow"
      :mode="mode"
      @input.native="getPickUpInfo"
      @numberInput="getPickUpInfo"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-slot:before-content>
        <div class="f-r-vc template" v-if="editing">
          <span class="title">Template</span>
          <el-input size="small" />
        </div>
      </template>
      <template v-slot:actions>
        <div class="buttons f-c">
          <div class="f-r">
            <el-button
              size="small"
              type="success"
              plain
              @click="editing = true"
              v-if="!editing"
            >
              Edit Picking Info
            </el-button>
            <el-button
              size="small"
              type="primary"
              plain
              @click="saveInfo"
              v-if="editing"
            >
              Save Info
            </el-button>
            <el-button
              size="small"
              type="danger"
              plain
              @click="
                value => {
                  editing = false
                  reset()
                }
              "
              v-if="editing"
            >
              Cancel
            </el-button>
          </div>
        </div>
      </template>
    </basic-form>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import { FormModes } from '@/core/configs/types'
// msg
import PagesMessage from '@/core/message/pages'
// apis
import { updateContainer } from '@/api/container'
// components
import BasicForm from '@/components/common/BasicForm.vue'
// models
import { PickUpInfoWrapUp, PickUpInfoForm } from '@/core/models/container'
export default {
  name: 'PickingUpInfo',
  components: {
    BasicForm
  },
  props: {
    containerId: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: Object,
      default: () => FormModes.SPARSE
    }
  },
  data() {
    return {
      FormModes,
      editing: false
    }
  },
  computed: {
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      return PickUpInfoWrapUp(this.value)
    },
    editInfo() {
      const form = cloneDeep(PickUpInfoForm)
      Object.values(form).forEach(one => {
        one.value = this.value ? this.value[one.key] : ''
      })
      return form
    }
  },
  methods: {
    getPickUpInfo(e) {
      this.$emit('input', this.$refs.infoForm.validateAllInputs()[1])
    },
    isEmpty,
    saveInfo() {
      const [passed, pickUpInfo] = this.$refs.infoForm.validateAllInputs()
      if (passed) {
        this.$confirm('Update Picking Up Info?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          updateContainer(this.containerId, {
            pickUpInfo: pickUpInfo
          }).then(res => {
            if (res) {
              this.editing = false
              PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
            }
          })
        })
      }
    },
    reset() {
      this.$emit('resetPickUpInfo')
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.pick-up-info {
  .buttons {
    gap: 10px;
  }
}

.template {
  padding: 10px 0;
  gap: 30px;

  .title {
    font-size: $regular-body-font-size;
  }
}
</style>
